import React from 'react';
import Nav from "react-bootstrap/Nav";
import Accordion from "react-bootstrap/Accordion";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSubsite, getUserCapabilities } from '../../reducers/auth';
import { current } from '@reduxjs/toolkit';
import styled from 'styled-components';

const AdminSideBar = (props) => {
  const { isSupervisor, isManager, isAdmin, isSuperAdmin, loading } = useSelector(state => state.auth);
  const currentSubsite = useSelector(getSubsite);
  const userCapabilities = useSelector(getUserCapabilities);

  const menuBg = currentSubsite.subsite_content?.menuBgColor || "#000000";
  const menuText = currentSubsite.subsite_content?.menuTextColor || "#FFFFFF";

  const StyledDiv = styled.div`
    &:hover {
      color: ${currentSubsite.subsite_content?.menuTextHoverColor ? currentSubsite.subsite_content?.menuTextHoverColor : "inherited"};
      // Add other hover styles as needed
    }
  `;

  // Accordion styled to blend with the dark sidebar
  const StyledAccordion = styled(Accordion)`
    --bs-accordion-bg: ${menuBg};
    --bs-accordion-color: ${menuText};
    --bs-accordion-border-color: rgba(255, 255, 255, 0.15);
    --bs-accordion-btn-color: ${menuText};
    --bs-accordion-btn-bg: ${menuBg};
    --bs-accordion-active-color: ${menuText};
    --bs-accordion-active-bg: ${menuBg};
    --bs-accordion-btn-focus-box-shadow: none;
    --bs-accordion-btn-icon-transform: rotate(-180deg);
    .accordion-button {
      font-weight: 600;
      padding: 10px 15px;
    }
    .accordion-button::after {
      filter: invert(1) grayscale(100%) brightness(200%);
    }
    .accordion-body {
      padding: 5px 0;
      background-color: ${menuBg};
    }
  `;

  return (
    <div id="adminSideBar" style={{ marginRight: 20, backgroundColor: currentSubsite.subsite_content?.menuBgColor ? currentSubsite.subsite_content?.menuBgColor : "#000000" }}>
      <Nav className=" d-none d-md-block sidebar" style={{ backgroundColor: currentSubsite.subsite_content?.menuBgColor ? currentSubsite.subsite_content?.menuBgColor : "#000000" }}>
        {(!isAdmin && !isSuperAdmin) && (<>
          {userCapabilities.map(capability => {
            if (capability.capabilityName === "ADD_NEW_HIRE_KITS")
              return (<Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/newhirekits"><StyledDiv>New Hire Kits</StyledDiv></Nav.Link>
              );
            if (capability.capabilityName === "VIEW_SURVEY")
              return (<Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/surveys"><StyledDiv>View Surveys</StyledDiv></Nav.Link>
              );
            if (capability.capabilityName === "PRINT_ITEM_REPORT")
              return (<Nav.Link key="PRINT_ITEM_REPORT" style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/printitemreport"><StyledDiv>Print Item Report</StyledDiv></Nav.Link>
              );

          })}
          {userCapabilities?.some(c =>
            c.capabilityName === "ADD_USER" ||
            c.capabilityName === "REMOVE_USER" ||
            c.capabilityName === "UPDATE_USER_BALANCE"
          ) && (
            <Nav.Link
              key="USERS_CAPABILITY"
              style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }}
              as={Link}
              to="/admin/users"
            >
              <StyledDiv>Users</StyledDiv>
            </Nav.Link>
          )}
        </>)}



        {(isAdmin || isSuperAdmin) && (<>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/home"><StyledDiv>Admin Home</StyledDiv></Nav.Link>
          <hr style={{ color: "#FFFFFF" }} />
          <h4 style={{ paddingLeft: 15, color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} >Admin</h4>
          <hr style={{ color: "#FFFFFF" }} />
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/usersbulk"><StyledDiv>Users Bulk Edit</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/categories"><StyledDiv>Categories</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/orders"><StyledDiv>Orders</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/catalog/0"><StyledDiv>Catalog</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/featured"><StyledDiv>Featured Items</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/allcatalog/1"><StyledDiv>Available Products</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/content"><StyledDiv>Page Content</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/communications"><StyledDiv>Communication</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/status"><StyledDiv>Site Status</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/users"><StyledDiv>Users</StyledDiv></Nav.Link>
          {userCapabilities.map(capability => {
            if (capability.capabilityName === "ADD_NEW_HIRE_KITS")
              return (<Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/newhirekits"><StyledDiv>New Hire Kits</StyledDiv></Nav.Link>
              );
          })}
          {(isSuperAdmin || userCapabilities?.some(c => c.capabilityName === "PRINT_ITEM_REPORT")) && (
            <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/printitemreport"><StyledDiv>Print Item Report</StyledDiv></Nav.Link>
          )}

        </>)}
        {(isSupervisor) && (<>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/users"><StyledDiv>Users</StyledDiv></Nav.Link>
          <Nav.Link style={{ color: currentSubsite.subsite_content?.menuTextColor ? currentSubsite.subsite_content?.menuTextColor : "#FFFFFF" }} as={Link} to="/admin/newhirekits"><StyledDiv>New Hire Kits</StyledDiv></Nav.Link>
        </>)}
        {isSuperAdmin && (
          <>
            <hr style={{ color: "#FFFFFF" }} />
            <h4 style={{ paddingLeft: 15, color: menuText }}>Super Admin</h4>
            <hr style={{ color: "#FFFFFF" }} />
            <StyledAccordion alwaysOpen defaultActiveKey={[]} flush>
              <Accordion.Item eventKey="users">
                <Accordion.Header>Users</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/super/users"><StyledDiv>User Manager</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/super/admins"><StyledDiv>Super Admins</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/super/titles"><StyledDiv>User Titles</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/registrations"><StyledDiv>Registration Requests</StyledDiv></Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="orders">
                <Accordion.Header>Orders</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/purchaseorders"><StyledDiv>Purchase Orders</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/super/orders"><StyledDiv>Order Manager</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/super/shipping"><StyledDiv>Shipping Admin</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/closedpos"><StyledDiv>Closed Purchase Orders</StyledDiv></Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="subsites">
                <Accordion.Header>Subsites</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/subsites"><StyledDiv>Subsites</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/shipping"><StyledDiv>Shipping</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/pricecalculation"><StyledDiv>Price Calculation</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/logos"><StyledDiv>Logos</StyledDiv></Nav.Link>
                  {currentSubsite.paymentOptions === "kit" && (
                    <Nav.Link style={{ color: menuText }} as={Link} to="/admin/newhirekits"><StyledDiv>Kit Items</StyledDiv></Nav.Link>
                  )}
                  {currentSubsite.paymentOptions !== "kit" && (
                    <Nav.Link style={{ color: menuText }} as={Link} to="/admin/newhirekits"><StyledDiv>New Hire Kit</StyledDiv></Nav.Link>
                  )}

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="products">
                <Accordion.Header>Products</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/addproduct"><StyledDiv>Add Product</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/igniteproducts"><StyledDiv>Ignite Products</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/printitems"><StyledDiv>Print Items</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/sands"><StyledDiv>S and S</StyledDiv></Nav.Link>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="surveys">
                <Accordion.Header>Surveys</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/surveys"><StyledDiv>Surveys</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/super/surveys"><StyledDiv>All Surveys</StyledDiv></Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="system">
                <Accordion.Header>System Admin</Accordion.Header>
                <Accordion.Body>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/maintenance"><StyledDiv>Maintenance</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/capabilities"><StyledDiv>Capabilities</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/decorators"><StyledDiv>Decorators</StyledDiv></Nav.Link>
                  <Nav.Link style={{ color: menuText }} as={Link} to="/admin/reports"><StyledDiv>Reports</StyledDiv></Nav.Link>

                </Accordion.Body>
              </Accordion.Item>
            </StyledAccordion>
          </>
        )}
      </Nav>
    </div>
  );
};
export default AdminSideBar;
